import { getToken, getToken2, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall, postAPICall2 } from "../axiosMethodCalls";
import Moment from "moment";
//GET
// franchise_sale_item_prices
export const getAllItemPrices = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "item_prices/get_all_franchise_sale_item_price",
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//GET
export const getAllItemPricesPotato = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "item_prices/get_all_franchise_sale_item_price",
            {
                requester: getUser(),
                token: getToken2(),
            },
            "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// GET SINGLE transfer
export const getItemPrices = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "item_prices/get_item_price",
            {
                requester: getUser(),
                token: getToken(),
                item_price_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// GET SINGLE transfer
export const getItemPricesPotato = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "item_prices/get_item_price",
            {
                requester: getUser(),
                token: getToken2(),
                item_price_id: id,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const getItemPriceByBranch = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "item_prices/units_per_item",
            // process.env.REACT_APP_LINK + "franchise_sale_item_prices/search",
            {
                requester: getUser(),
                token: getToken(),
                branch_id: data.branch_id,
                name: data.name,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
// CREATE ITEM PRICE V1
// export const createItemPrice = async (data, price_level_details) => {
//     try {
//         var formData = new FormData()
//         formData.append("requester", getUser())
//         formData.append("token", getToken()?.replace(/['"]+/g, ""))
//         formData.append("item_id", data.item_id)

//         // price_level_details?.forEach((data) => {
//         //     formData.append("price_level_id[]", data.price_level_id ? data.price_level_id : "")
//         // })
        
//         price_level_details?.forEach((data) => {
//             data?.unit?.forEach((units) => {
//                 formData.append("price_level_id[]", data.price_level_id ? data.price_level_id : "")
//                 formData.append("item_unit_id[]", units?.items?.item_unit_id)
//                 formData.append("unit[]", units?.items?.unit)
//                 formData.append("selling_price[]", units.selling_price ? units.selling_price : "")
//                 formData.append("wholesale_price[]", units.wholesale_price ? units.wholesale_price : "")
//                 formData.append("retail_price[]", units.retail_price ? units.retail_price : "")
//                 formData.append("special_price_1[]", units.special_price_1 ? units.special_price_1 : "")
//                 formData.append("special_price_2[]", units.special_price_2 ? units.special_price_2 : "")
//                 formData.append("special_price_3[]", units.special_price_3 ? units.special_price_3 : "")
//                 formData.append("vat_in[]", units.vat_in ? units.vat_in : "")
//                 formData.append("vat_ex[]", units.vat_ex ? units.vat_ex : "")
//                 formData.append("vat_component[]", units.vat_component ? units.vat_component : "")
//                 formData.append("margin[]", units.margin ? units.margin : "")
//                 formData.append("cost_price[]", units.cost_price ? units.cost_price : "")

//             })
//         })

//         const response = await postAPICall(
//             process.env.REACT_APP_LINK + "item_prices/generate_multiple",formData
//         );
//         return { data: response.data };
//     } catch (error) {
//         return { error: error };
//     }
// };

// CREATE ITEM PRICE V2
export const createItemPrice = async (data, price_level_details) => {
    try {
        var formData = new FormData()
        formData.append("requester", getUser())
        formData.append("token", getToken()?.replace(/['"]+/g, ""))
        formData.append("item_id", data.item_id)

        // price_level_details?.forEach((data) => {
        //     formData.append("price_level_id[]", data.price_level_id ? data.price_level_id : "")
        // })
        
        price_level_details?.forEach((data) => {
            data?.forEach((units) => {
                formData.append("price_level_id[]", units.price_level_id ? units.price_level_id : "")
                formData.append("item_unit_id[]", units?.id)
                formData.append("unit[]", units?.unit_from)
                formData.append("selling_price[]", units.selling_price ? units.selling_price : "")
                formData.append("wholesale_price[]", units.wholesale_price ? units.wholesale_price : "")
                formData.append("retail_price[]", units.retail_price ? units.retail_price : "")
                formData.append("special_price_1[]", units.special_price_1 ? units.special_price_1 : "")
                formData.append("special_price_2[]", units.special_price_2 ? units.special_price_2 : "")
                formData.append("special_price_3[]", units.special_price_3 ? units.special_price_3 : "")
                formData.append("vat_in[]", units.vat_in ? units.vat_in : "")
                formData.append("vat_ex[]", units.vat_ex ? units.vat_ex : "")
                formData.append("vat_component[]", units.vat_component ? units.vat_component : "")
                formData.append("margin[]", units.margin ? units.margin : "")
                formData.append("cost_price[]", units.cost_price ? units.cost_price : "")

            })
        })

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "item_prices/generate_multiple",formData
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateItemPrice = async (data) => {
    
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "item_prices/update",
            {
                requester: getUser(),
                token: getToken(),
                item_price_id: data.id,
                item_id: data.item_id,
                item_unit_id: data.item_unit_id,
                unit: data.unit,

                price_level_id: data.price_level_id,
                selling_price: data.selling_price,
                wholesale_price: data.wholesale_price,
                retail_price: data.retail_price,
                special_price_1: data.special_price_1,
                special_price_2: data.special_price_2,
                special_price_3: data.special_price_3,
                vat_in: data.vat_in,
                vat_ex: data.vat_ex,
                vat_component: data.vat_component,
                margin: data.margin,
                cost_price: data.cost_price,

            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// PARA SEARCH SA ITEM PRICES
export const searchItemPrice = async (data) => {
    
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "item_prices/search",
            {
                requester: getUser(),
                token: getToken(),
                item_name: data.name,
                anything: data.anything,
                type: data.type,
                price_level_id: data.price_level_id,
                category_name: data.category,
                subcategory_name: data.subcategory,
            }
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const searchItemPricePotato = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "item_prices/search",
            {
                requester: getUser(),
                token: getToken2(),
                item_name: data.name,
                type: data.type,
                
            }, "potato"
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// PARA SEARCH SA ITEM
export const searchFranchiseSaleItem = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "items/search",
            {
                requester: getUser(),
                token: getToken(),
                is_for_sale: "0",
            }
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const searchFranchiseSaleItemPotato = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "items/search",
            {
                requester: getUser(),
                token: getToken2(),
                is_for_sale: "0",
            }, "potato"
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const searchDsrItem = async (is_dsr, data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "items/search",
            {
                requester: getUser(),
                token: getToken(),
                is_dsr: is_dsr,
                name: data.name,
                type: data.type,
            }
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const searchDsrItemPotato = async (is_dsr, data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "items/search",
            {
                requester: getUser(),
                token: getToken2(),
                is_dsr: is_dsr,
                name: data.name,
                type: data.type,
            }, "potato"
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const deleteItemPrices = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "item_prices/delete",
            {
                requester: getUser(),
                token: getToken(),
                item_price_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// GET SINGLE transfer
export const deleteItemPricesPotato = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "item_prices/delete",
            {
                requester: getUser(),
                token: getToken2(),
                item_price_id: id,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateItemForSale = async (id, value) => {
    try {
        var info = {
            requester: getUser(),
            token: getToken(),
            item_id: id,
            is_for_sale: value,
            
        };
        //

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "items/update",
            { ...info }
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateItemForSalePotato = async (id, value) => {
    try {
        var info = {
            requester: getUser(),
            token: getToken2(),
            item_id: id,
            is_for_sale: value,
            
        };
        //

        const response = await postAPICall(
            process.env.REACT_APP_POTATO + "items/update",
            { ...info }, "potato"
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateDsr = async (id, value) => {
    try {
        var info = {
            requester: getUser(),
            token: getToken(),
            item_id: id,
            is_dsr: value,
            is_active: value,
            
        };
        //

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "items/update",
            { ...info }
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateDsrPotato = async (id, value) => {
    try {
        var info = {
            requester: getUser(),
            token: getToken2(),
            item_id: id,
            is_dsr: value,
            is_active: value,
        };
        //

        const response = await postAPICall(
            process.env.REACT_APP_POTATO + "items/update",
            { ...info }, "potato"
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const updateDsrStatus = async (id, value) => {
    try {
        var info = {
            requester: getUser(),
            token: getToken(),
            item_id: id,
            // is_dsr: value,
            is_active: value,
            
        };
        //

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "items/update",
            { ...info }
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateDsrStatusPotato = async (id, value) => {
    try {
        var info = {
            requester: getUser(),
            token: getToken2(),
            item_id: id,
            // is_dsr: value,
            is_active: value,
        };
        //

        const response = await postAPICall(
            process.env.REACT_APP_POTATO + "items/update",
            { ...info }, "potato"
        );
        //
        return { response: response.data };
    } catch (error) {
        return { error: error.response };
    }
};